package br.com.vvrefeicoes.portal.core.storage

import kotlinx.browser.window

actual fun createKeyValueStorage(): KeyValueStorage = BrowserKeyValueStorage

private object BrowserKeyValueStorage : KeyValueStorage {
    override fun getString(key: String): String? = window.localStorage.getItem(key)

    override fun putString(
        key: String,
        value: String,
    ) {
        window.localStorage.setItem(key, value)
    }

    override fun remove(key: String) {
        window.localStorage.removeItem(key)
    }
}
